import React from 'react';
import Header from '../../../layouts/doctor/DoctorHeader';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { Locationbasicinfo } from './Locationbasicinfo';
import { Locationcontact } from './Locationcontact';
import { Locationaddress } from './Locationaddress';
import { Locationbillingdetails } from './Locationbillingdetails';

export const Locationprofile = () => {
  const [value, setValue] = React.useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
    <Header pageTitle="Location Profile" />
    <div className="cardOuter">
      <div className="cardheads">
        <div className="cardTitle">
        Location Details
        </div>
      </div>
      <div className="cardcontents">
      <TabContext className="tabsDesigns" value={value}>
              <Tabs className='butoontabdesigns' onChange={handleChange} >
                <Tab label="Basic Information" value="1" />
                <Tab label="Contact Information" value="2" />
                <Tab label="Address Details" value="3" />
                <Tab label="Payment Details" value="4" />
              </Tabs>
              <TabPanel className='tabpanelControl' value="1">
                <Locationbasicinfo/>
              </TabPanel>
              <TabPanel className='tabpanelControl' value="2">
                <Locationcontact/>
              </TabPanel>
              <TabPanel className='tabpanelControl' value="3">
                <Locationaddress/>
              </TabPanel>
              <TabPanel className='tabpanelControl' value="4">
              <Locationbillingdetails/>
              </TabPanel>

          </TabContext>
    </div>
    </div>
    </div>
  )
}
